export default __webpack_public_path__ + "static/media/43940CCE-9340-4F3A-AA2A-101E8776DDAB_1_105_c.eaa6bde9.jpeg";